import React from "react";

import { CareerIcon } from "@components/career-icon";

import { useApiRequest } from "@lib/hooks";
import { setCareerInfo, sortByNameFn } from "@services/insights.utils";
import { useContainer } from "@src/contexts/container-context";
import { useCareerImageUrls } from "@src/hooks/queries";

import "./trainee.ce-top-careers.scss";

const MaxCareersDisplay = 3;

export function TraineeCeTopCareers({ trainee }) {
  const { userId } = trainee;
  const { insightsService, simulationsService } = useContainer();

  const { response: topCareers } = useApiRequest(async () => {
    const topCareers = await insightsService.getCEUserTopCareers(userId);
    const careersInfo = await setCareerInfo({
      simulationsService,
      sims: topCareers ?? [],
    });

    return careersInfo
      .slice(0, MaxCareersDisplay)
      .map((c) => ({
        name: c.occupationName,
        code: c.clusterCode,
        rating: c.starRating,
        learningExperienceId: c.learningExperienceId,
      }))
      .sort(sortByNameFn);
  });

  const careerIconUrls = useCareerImageUrls(
    topCareers,
    (career) => career.learningExperienceId,
    (career) => ({ learningExperienceId: career.learningExperienceId })
  );

  return (
    topCareers &&
    topCareers?.length > 0 && (
      <div className="highest-rated-container">
        <h2>Highest Rated Careers</h2>
        <div>
          {topCareers?.map((c, index) => (
            <CareerIcon
              key={`${c.code}-${index}`}
              name={c.name}
              clusterCode={c.code}
              rating={c.rating}
              iconUrl={careerIconUrls.get(c.learningExperienceId)}
            />
          ))}
        </div>
      </div>
    )
  );
}
